import { Provider } from '@angular/core';

import { ApplyToJobShiftsService } from '../Domain/Port/ApplyToJobShifts/apply-to-job-shifts.service';
import { BackendApplyToJobShiftsService } from '../Infrastructure/Adapter/ApplyToJobShifts/backend-apply-to-job-shifts.service';

export const applyToJobShiftsProvider = (): Provider[] => {
    return [
        {
            provide: ApplyToJobShiftsService,
            useExisting: BackendApplyToJobShiftsService
        }
    ];
};
